import { useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Label, Input, FormGroup, Collapse} from 'reactstrap';
import './Lmu.css';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

const PastureDrainageForm = ({ form, handleFormFieldChange }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);

    const handleItemExpandCollapse = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    return (
        <Card className="my-3">
            <CardHeader className="item-header" onClick={handleItemExpandCollapse}>
                
                <Row>
                    <Col sm="11"><h6>Pasture & Drainage</h6></Col>
                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    <Row className="my-2">
                        <Col sm="6">
                            <FormGroup>
                                <Label for="dominantPastureSpecies">Dominant Pasture Species</Label>
                                <Input
                                    bsSize="sm"
                                    id="dominantPastureSpecies"
                                    name="dominantPastureSpecies"
                                    type="select"
                                    value={form.dominantPastureSpecies}
                                    onChange={handleFormFieldChange}
                                >
                                    <option value={0} >Select Dominant Pasture Species Type</option>
                                    {form.dominantPastureSpeciesList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <Label for="pastureBlockProductivityPercentage">Pasture Block Productivity %</Label>
                                <Input
                                    type="text"
                                    name="pastureBlockProductivityPercentage"
                                    id="pastureBlockProductivityPercentage"
                                    bsSize="sm"
                                    value={form.pastureBlockProductivityPercentage}
                                    onChange={handleFormFieldChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            <FormGroup check>
                                <Label
                                    check
                                    for="isArtificiallyDrained"
                                >
                                    Artificially Drained?
                                </Label>
                                <Input
                                    defaultChecked={form.isArtificiallyDrained}
                                    id="isArtificiallyDrained"
                                    name="isArtificiallyDrained"
                                    type="checkbox"
                                    value={form.isArtificiallyDrained}
                                    onChange={handleFormFieldChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="3">
                            <FormGroup>
                                <Label
                                    for="artificiallyDrainedPercentage"
                                >
                                    Artificially Drained %
                                </Label>
                                <Input
                                    type="text"
                                    name="artificiallyDrainedPercentage"
                                    id="artificiallyDrainedPercentage"
                                    bsSize="sm"
                                    value={form.artificiallyDrainedPercentage}
                                    onChange={handleFormFieldChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <Label for="artificialDrainageType">Artificial Drainage Type</Label>
                                <Input
                                    bsSize="sm"
                                    id="artificialDrainageType"
                                    name="artificialDrainageType"
                                    type="select"
                                    value={form.artificialDrainageType}
                                    onChange={handleFormFieldChange}
                                >
                                    <option value={0} >Select Artificial Drainage Type</option>
                                    {form.artificialDrainageTypeList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="6">
                            <FormGroup>
                                <Label for="susceptibilityToPugging">Susceptibility To Pugging</Label>
                                <Input
                                    bsSize="sm"
                                    id="susceptibilityToPugging"
                                    name="susceptibilityToPugging"
                                    type="select"
                                    value={form.susceptibilityToPugging}
                                    onChange={handleFormFieldChange}
                                >
                                    <option value={0} >Select Susceptibility to Pugging Type</option>
                                    {form.susceptibilityToPuggingList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm="6">
                            <FormGroup>
                                <Label for="irrigationScheduled">Irrigation Scheduled</Label>
                                <Input
                                    bsSize="sm"
                                    id="irrigationScheduled"
                                    name="irrigationScheduled"
                                    type="select"
                                    value={form.irrigationScheduled}
                                    onChange={handleFormFieldChange}
                                >
                                    <option value={0} >Select Irrigation Schedule</option>
                                    {form.irrigationScheduledList.map(c =>
                                        <option key={c.id} value={c.id}>{c.value}</option>
                                    )}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </Card>
    )
}

export default PastureDrainageForm